import React, { Component } from 'react';
import { Button, Row, Col } from 'react-bootstrap';

import FileField from './FileField';

class DocumentField extends Component {
  constructor(props){
    super(props)
    this.state = {
      file: {
        url: null,
        type: null,
        size: null,
        name: null,
        blob: null,
      }
    }
    this.handleOnChange = this.handleOnChange.bind(this)
    this.deleteFile = this.deleteFile.bind(this)
  }

  deleteFile(event){
    event.preventDefault();
    this.setState({
      ...this.state,
      file: {
        url: null,
        type: null,
        size: null,
        name: null,
        blob: null,
      }
    })
    this.props.onChange(null);
  }

  handleOnChange(value){
    this.setState({
        ...this.state,
        file:{
            url: URL.createObjectURL(value),
            type: value.type,
            size: value.size,
            name: value.name,
            blob: value
        }
    })
    this.props.onChange(value);
  }

  shortFileName(fileName){
    if(fileName.length > 17){
      return fileName.slice(0, 16) + '...'
    }else{
      return fileName
    }
  }

  render() {
    const {file} = {...this.state}
    let imagePreviewStyle = {
      width: 'initial',
      height: 'initial'
    }
    if(file){
      if(file.width > file.height){
        imagePreviewStyle['maxWidth'] = '50px';
      }else{
        imagePreviewStyle['maxHeight'] = '50px';
      }
    }

  const cancelButton = (<button className={'btn btn-default btn-upload-red'} onClick={this.deleteFile}>
                          <span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
                        </button>);

  let actionButton;
  if(this.props.updating){
    actionButton = (<button className={'btn btn-default'} disabled={true}>
                      <i className="fa fa-refresh fa-spin fa-lg fa-fw"></i>
                    </button>);
  }else if(file.blob){
    actionButton = cancelButton;
  }else{
    actionButton = (<FileField onChange={this.handleOnChange}/>);
  }

  let description = (<Row className="terms_row">
                      <Col className="terms_col terms_checkbox pd-vcenter" xs={9} md={10} lg={10}><span>{this.props.label}</span></Col>
                      <Col className="terms_col pd-vcenter" xs={3} md={2} lg={2}>
                        <div className="btn-group" role="group" >
                          {actionButton}
                        </div>
                      </Col>
                    </Row>);
  if (file.blob){
    let imageRepresetation;

    if(file.type.search("image/") > -1){
      imageRepresetation = (<img src={file.url} key={file.url} style={imagePreviewStyle}></img>);
    }
    else if(file.type.search("/pdf") > -1){
      imageRepresetation = (<div><i className="fa fa-file-pdf-o fa-3x fa-fw"></i></div>);
    }
    else{
      imageRepresetation = (<div><i className="fa fa-file fa-3x fa-fw"></i></div>);
    }
    description =   (<Row className="terms_row">
                      <Col className="terms_col terms_checkbox pd-vcenter text-center" xs={2} md={2} lg={2}>
                          {imageRepresetation}
                      </Col>
                      <Col className="terms_col terms_checkbox pd-vcenter" xs={7} md={8} lg={8}>
                          <span>{this.shortFileName(file.name)}</span>
                      </Col>
                      <Col className="terms_col pd-vcenter" xs={3} md={2} lg={2}>
                        <div class="btn-group" role="group" >
                          {actionButton}
                        </div>
                      </Col>
                    </Row>);
  }


    return description;
  }
}
module.exports = DocumentField


/** WEBPACK FOOTER **
 ** ./src/components/DocumentField.js
 **/